import { Input } from '@cast/design-system';

export const InvalidInput = () => <Input readOnly value="--:--" label="At:" />;
